export const DEPRECATED_ENGINES = [
  'bookings',
  'marketing',
  'legal',
  'billing',
  'usage',
  'business activity',
  'cpq',
  'provisioning',
  'product'
];
